let Proposition = (function () {
  function Proposition (textToAdd, options) {
    this.textToAdd = textToAdd
    this.textToShow = options.textToShow || textToAdd
    this.explanationKey = options.explanationKey
    this.textToRemove = options.textToRemove || ''
    this.description = options.description || ''
    this.options = options
    // console.log(options, this)
  }

  Proposition.prototype.getOption = function (name) {
    return this.options[name]
  }

  Proposition.prototype.transform = function (string, fromPosition) {
    var end, start
    if (fromPosition == null) {
      fromPosition = -1
    }
    if (fromPosition === -1) {
      fromPosition = string.length
    }
    start = string.substring(0, fromPosition)
    end = string.substring(fromPosition)
    if (start.lastIndexOf(this.textToRemove) + this.textToRemove.length === string.length) {
      start = start.substring(0, start.length - this.textToRemove.length)
    } else if (start.lastIndexOf('"' + this.textToRemove + '"') + this.textToRemove.length + 2 === string.length) {
      start = start.substring(0, start.length - this.textToRemove.length - 2)
    }
    if (start[start.length - 1] === ':') {
      start += ' '
    }
    return start + this.textToAdd + end
  }

  Proposition.prototype.getTextToShow = function () {
    return this.textToShow
  }

  Proposition.prototype.onSelect = function () {
    let callback = this.getOption('onSelect')
    if (callback) {
      callback.apply(this)
    }
  }

  return Proposition
})()

export default Proposition



// WEBPACK FOOTER //
// ./src/components/shared/Proposition.js